import { gql } from '@apollo/client';

/**
 * GraphQL query to fetch the current session
 */
export const GET_SESSION = gql`
  query GetSession {
    session {
      user {
        id
        name
        email
        roles
        picture
      }
      providerId
      authenticated
    }
  }
`;
